import { IPermission } from '../../../../../compiler/global.interface'

export type PermissionAction = 'read' | 'create' | 'update' | 'delete' | 'approve'
export type PermissionInheritanceMap = Record<
  string,
  Partial<Record<PermissionAction, string[]>>
>

export interface GroupPermissionSnapshot {
  groupUuid: string
  groupName: string
  permissionData: IPermission[]
}

export const permissionActions: PermissionAction[] = [
  'read',
  'create',
  'update',
  'delete',
  'approve',
]

export const buildPermissionInheritanceMap = (
  snapshots: GroupPermissionSnapshot[],
): PermissionInheritanceMap => {
  const result: PermissionInheritanceMap = {}
  snapshots.forEach((snapshot) => {
    snapshot.permissionData.forEach((permission) => {
      permissionActions.forEach((action) => {
        if (Number(permission[action]) !== 1) return
        const role = result[permission.roles_code] || {}
        const sources = role[action] || []
        if (!sources.includes(snapshot.groupName)) {
          role[action] = [...sources, snapshot.groupName]
        }
        result[permission.roles_code] = role
      })
    })
  })
  return result
}

export const isPermissionEffective = (
  permission: IPermission,
  action: PermissionAction,
  inherited: PermissionInheritanceMap,
) => Number(permission[action]) === 1 || (inherited[permission.roles_code]?.[action]?.length || 0) > 0

export const countEffectivePermissionRoles = (
  permissions: IPermission[] = [],
  inherited: PermissionInheritanceMap = {},
) =>
  permissions.filter((permission) =>
    permissionActions.some((action) => isPermissionEffective(permission, action, inherited)),
  ).length
